<template>

  <div :style="{background:stageBackground}" :class="['stage', {'is-3d':(stageSettings.show_perspective && !stageSettings.show_measure), 'show-measure':stageSettings.show_measure,'show-gaps':stageSettings.show_framegaps}]">
    
    <b-message v-if="showMessage" title="Open Kitchen Builder" type="is-rounded is-medium" has-icon icon-pack="fas" class="notice" style="margin:auto; max-width:600px; white-space: normal;">
      <p>Build your customized outdoor kitchen by clicking on the Modules to the right. By using this Open Kitchen Builder, you accept Röshults <a target="_blank" href="https://roshults.com">Privacy Policy</a>.</p>
    </b-message>

    <div class="items">

      <!-- <draggable class="draggable framerow" v-model="config" :options="{ group:'frames', handle:'.drag-handle-frame', animation:0}" > -->

        <component :is="getFrameComponent(group.frame.id)" @dragstart.native.self="rewriteDragImg(group.frame.icon, $event)" :canSelect="true" :showShadow="true" :moduleID="group.frame.id" :group="group" v-for="(group, groupIndex) in config" :index="groupIndex" :key="group.rand" :size="getGroupLength(group)">
          
            <Module v-for="(item, index) in group.items" slot="module" 
              @click.native="handleModuleClick(item, [groupIndex, 'items', index])" 
              @dragstart.native="rewriteDragImg(item.icon, $event)"
              :data-icon="item.icon"
              :moduleID="item.id" 
              :showModuleActions="true" 
              :settings="item.settings" 
              :item="item" 
              :itemIndex="index"
              :groupIndex="groupIndex"
              :key="item.itemKey"
              >
            </Module>
            
        </component>

       <!-- </draggable>  -->

     
    </div>

  </div>
  
</template>

<script>



import OpenFrame from './frames/OpenFrame'
import Sideboard from './frames/Sideboard'
import Cabinet from './frames/Cabinet'
import draggable from 'vuedraggable'

import { EventBus } from '@/utils/event-bus.js'
import Module from './Module'
import {mapActions, mapGetters} from 'vuex'


export default {

  name: 'Stage',

  data:function(){
    return{
      configurations: []
    }
  },

  props: {
    sectionModels:{}
  
  },

  created(){
    // this.$store.dispatch('LOAD_SECTIONS');
    // this.$store.dispatch('LOAD_ATTRIBUTES');
    // this.$store.dispatch('LOAD_MODELS');
  },

  mounted(){
    EventBus.$on('item-added', () => {
      if(this.$el.scrollWidth > this.$el.clientWidth){
        var maxScrollLeft = this.$el.scrollWidth - this.$el.clientWidth;
        this.$el.scrollLeft = maxScrollLeft;
      }
    });
  },

  methods:{

    ...mapActions(['EDIT_ITEM','SET_OPTIONS']),

    rewriteDragImg(icon, event) {  
      var dragIcon = document.createElement('img');
      dragIcon.src = icon;
      event.dataTransfer.setDragImage(dragIcon, 0, 60);
    },

    scrollMax(){
      if(this.$el.scrollWidth > this.$el.clientWidth){
        var maxScrollLeft = this.$el.scrollWidth - this.$el.clientWidth;
        this.$el.scrollLeft = maxScrollLeft;
      }
    },

    getFrameComponent(id){
      return this.all_sections[id].component;
    },
    
    getGroupLength(group){

      if(typeof group !== 'undefined' && group.hasOwnProperty('items') && group.items.length > 0) {        
       return group.items.length;
      }else{
        return 1;
      }

    },

    handleModuleClick(item, path){
      this.EDIT_ITEM({item, path});
    },

    handleDrag(evt){
      console.log(evt);
      
    }

  },

  data() {
      return{

      }
  },

  computed:{

    ...mapGetters(['stageSettings', 'getTexture', 'all_sections']),

    showMessage(){
      return !this.config.length > 0;
    },

    config: {
        get() {
            return this.$store.state.config
        },
        
        set(value) {
          this.$store.commit('updateConfig', value);
        }
    },

    stageBackground(){
      
      var texture = this.getTexture(this.stageSettings.stage_background);
        
      if(texture){
        return texture;
      }
      
    }

  },

  

  components:{
    Module,
    draggable,
    OpenFrame,
    Sideboard,
    Cabinet
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .stage{
    background-image: linear-gradient(to top, #dfe9f3 0%, #dfe9f3 30%,#d0d9e2 30%,  white 100%);
    overflow-x: auto;
    white-space: nowrap;
    display:flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow-x: scroll;
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
    color-adjust: exact !important;  
    background-blend-mode: soft-light, screen;  
  }
  

  .stage.is-3d{
    perspective: 1500px;
    perspective-origin: 50% 30%;
    transform-style: preserve-3d;
  }


  .items{
    transform-style: preserve-3d;
    transform:translateY(-90px) ;
    margin:0 100px;

     
    /* transform:rotateY(40deg) rotateZ(-23deg) rotateX(-12deg); */
  }

  
  .frame:last-of-type{
    margin-right:100px;
  }

  .is-dragging{
   left:0;
  }

  .stage::-webkit-scrollbar {
    width: 1em;
    height:30px;
}
 
.stage::-webkit-scrollbar-track {
  background-color:transparent;
  
}
 
.stage::-webkit-scrollbar-thumb {
  background-color: #333;
  border-radius:4px;
}




  @media only screen and (max-width: 1087px) {
    
    .notice{
      margin:20px !important;
    }

    .stage.is-3d{
      perspective-origin: 50% -30%;
    }

    .stage::-webkit-scrollbar {
      height:6px;
    }
  }

 

</style>
